import { render, staticRenderFns } from "./DashboardItemsConfigHeader.vue?vue&type=template&id=507ac15d"
import script from "./DashboardItemsConfigHeader.vue?vue&type=script&lang=js"
export * from "./DashboardItemsConfigHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports